import React from "react";

export default function Footer() {
  return (
    <div>
      <a
        href="https://github.com/Belzie1300/bel-weather-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source
      </a>{" "}
      code by Belinda Dinh and{" "}
      <a
        href="https://app.netlify.com/sites/melodic-muffin-9bb97d/overview"
        target="_blank"
        rel="noreferrer"
      >
        {" "}
        hosted on Netlify
      </a>
    </div>
  );
}
